import { useState } from 'react'
import Head from 'next/head'
import Router from 'next/router'
import VerificationInfo from '../../containers/get-verified/landing/verification-info'
import AccountVerification from '../../containers/get-verified/account-verification'
import HeroSection from '../../containers/get-verified/landing/hero-section'
import UpcomingAuctions from '../../components/upcoming-auctions'
import CTACards from '../../containers/get-verified/landing/cta-cards'
import MessageModal from '../../components/message-modal'
import { VIEWS } from '../../containers/auth/modals'
import Features from '../../components/features'
import { useAuth } from '../../contexts/auth'
import Banner from '../../components/banner'
import { ROUTES } from '../../constants'

export default function GetVerified() {
  const [{ isAuthenticated, userDetails }, { setAuthModal }] = useAuth()
  const [isAlreadyVerifiedModalOpen, setIsAlreadyVerifiedModalOpen] = useState()

  const handleGetStartedClick = () => {
    if (!isAuthenticated) setAuthModal({ open: true, view: VIEWS.Login })
    else if (userDetails.verified) setIsAlreadyVerifiedModalOpen(true)
    else Router.push(ROUTES.Account)
  }

  return (
    <>
      <Head>
        <title>Sell Your Car Online Safely | Get Verified With privauto</title>
        <meta
          name='description'
          content='Want to sell your car online and get the most money for your used car? Get verified at DriversExchange.com and sell your car safely and securely.'
        />
      </Head>

      {isAlreadyVerifiedModalOpen && (
        <MessageModal
          title='Verification'
          text='You are Verified'
          onClose={() => Router.push(ROUTES.Account)}
        />
      )}
      {isAuthenticated && !userDetails.verified ? (
        <AccountVerification />
      ) : (
        <>
          <HeroSection onGetStartedClick={handleGetStartedClick} />

          <div className='container'>
            <section className='verificationInfoSection'>
              <VerificationInfo />
            </section>

            <section>
              <Features />
            </section>

            <section className='ctaSection'>
              <CTACards />
            </section>
          </div>

          <section className='auction'>
            <UpcomingAuctions />
          </section>

          <section className='banner'>
            <Banner />
          </section>

          <style jsx>{`
            .container {
              max-width: 193rem;
              width: 100%;
              margin: 0 auto;
              padding: 0 4rem;
            }

            .verificationInfoSection {
              max-width: 153.1rem;
              width: 100%;
              margin: 4.9rem auto 8rem;
            }

            .ctaSection {
              margin: 7.9rem auto 7.4rem;
            }

            .auction {
              margin: 0 0 8rem;
            }

            .banner {
              padding: 0 4rem;
            }

            @media (max-width: 1024px) {
              .container {
                max-width: 100%;
                padding: 0 1.1rem 2rem;
              }

              .verificationInfoSection {
                margin: 1.5rem auto 3.6rem;
              }

              .ctaSection {
                margin: 3.2rem auto 4.9rem;
              }

              .auction {
                margin: 0 0 2rem;
              }

              .banner {
                padding: 0 1.1rem;
              }
            }
          `}</style>
        </>
      )}
    </>
  )
}

GetVerified.getInitialProps = () => ({
  namespacesRequired: ['common'],
})
